import { render, staticRenderFns } from "./SpectrumCustomizerOverlay.vue?vue&type=template&id=11956b92&"
import script from "./SpectrumCustomizerOverlay.vue?vue&type=script&lang=js&"
export * from "./SpectrumCustomizerOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports